/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FinancialClassSimpleViewModel } from './financialClassSimpleViewModel';
import { LocationSimpleViewModel } from './locationSimpleViewModel';
import { InsuranceSimpleViewModel } from './insuranceSimpleViewModel';
import { ProviderSimpleViewModel } from './providerSimpleViewModel';
import { CodeViewModel } from './codeViewModel';
import { GuarantorDetailsViewModel } from './guarantorDetailsViewModel';
import { PartnerEncounterViewModel } from './partnerEncounterViewModel';
import { VisitDetailsViewModel } from './visitDetailsViewModel';
import { DatasetSimpleViewModel } from './datasetSimpleViewModel';

export interface PatientSummaryDetailsViewModel {
  id?: string;
  datasetId?: string;
  guarantorId?: string;
  accountNumber?: number;
  readonly accountNumberDisplay?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  middleName?: string | null;
  suffix?: string | null;
  birthDate?: string;
  sex?: string | null;
  ssn?: string | null;
  medicalRecordNumber?: string | null;
  defaultAdmissionDate?: string | null;
  defaultDischargeDate?: string | null;
  defaultInjuryDate?: string | null;
  defaultInjuryEmploymentCode?: string | null;
  defaultAccidentType?: string | null;
  defaultLocationId?: string | null;
  defaultAttendingProviderId?: string | null;
  defaultReferringProviderId?: string | null;
  defaultAuthNumber?: string | null;
  defaultHoldInsuranceBilling?: boolean | null;
  defaultHoldPatientBilling?: boolean | null;
  primaryDiagnosisCodeId?: string | null;
  secondaryDiagnosisCodeId?: string | null;
  tertiaryDiagnosisCodeId?: string | null;
  quarternaryDiagnosisCodeId?: string | null;
  primaryInsurance?: InsuranceSimpleViewModel;
  secondaryInsurance?: InsuranceSimpleViewModel;
  tertiaryInsurance?: InsuranceSimpleViewModel;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  stateCode?: string | null;
  zip?: string | null;
  countryCode?: string | null;
  homePhone?: string | null;
  workPhone?: string | null;
  mobilePhone?: string | null;
  email?: string | null;
  useAlternateMailingAddress?: boolean;
  alternateName?: string | null;
  alternateAddress1?: string | null;
  alternateAddress2?: string | null;
  alternateCity?: string | null;
  alternateStateCode?: string | null;
  alternateZip?: string | null;
  alternateCountryCode?: string | null;
  employerName?: string | null;
  employerAddress1?: string | null;
  employerAddress2?: string | null;
  employerCity?: string | null;
  employerStateCode?: string | null;
  employerZip?: string | null;
  employerCountryCode?: string | null;
  latestProcedureTransaction?: string | null;
  lastPaymentDate?: string | null;
  lastPatientPaymentDate?: string | null;
  totalBalanceDue?: number;
  totalBalanceAged30?: number;
  totalBalanceAged60?: number;
  totalBalanceAged90?: number;
  totalBalanceAged120?: number;
  totalBalanceAged150?: number;
  totalBalanceAgedOver150?: number;
  monthsAtZeroBalance?: number;
  latestDelinquency?: number;
  patientBalance?: number;
  insuranceBalance?: number;
  patientUnappliedBalance?: number;
  lastStatementDate?: string | null;
  lastStatementAmount?: number;
  holdStatement?: boolean;
  statementHoldReason?: string | null;
  statementHoldDate?: string | null;
  financialClassId?: string;
  bannerMessage?: string | null;
  letterId?: string | null;
  defaultPlaceOfServiceId?: string | null;
  financialClass?: FinancialClassSimpleViewModel;
  defaultLocation?: LocationSimpleViewModel;
  defaultPlaceOfService?: CodeViewModel;
  defaultAttendingProvider?: ProviderSimpleViewModel;
  defaultReferringProvider?: ProviderSimpleViewModel;
  primaryDiagnosisCode?: CodeViewModel;
  secondaryDiagnosisCode?: CodeViewModel;
  tertiaryDiagnosisCode?: CodeViewModel;
  quarternaryDiagnosisCode?: CodeViewModel;
  generateStatementOnDemand?: boolean | null;
  holdDelinquencyCodeOnDemand?: boolean | null;
  hasImaginePayPayments?: boolean | null;
  dataset?: DatasetSimpleViewModel;
  visits?: Array<VisitDetailsViewModel> | null;
  guarantor?: GuarantorDetailsViewModel;
  unpostedVisits?: Array<PartnerEncounterViewModel> | null;
}
